const sanitizeDownloadTitle = (title: string) => {
  return title.replace(/\./g, '')
}

export default sanitizeDownloadTitle
